import { Box, Text, styled } from '@ltvco/refresh-lib/theme';
import { AddPhotoAlternate } from '@mui/icons-material';

interface DragDropOverlayProps {
  isVisible: boolean;
}

const OverlayContainer = styled(Box)(() => ({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  zIndex: 9998,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  pointerEvents: 'none',
}));

const ContentBox = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(255, 255, 255, 0.9)',
  borderRadius: theme.spacing(3),
  padding: theme.spacing(4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  maxWidth: 400,
  margin: theme.spacing(2),
}));

const IconContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  width: 120,
  height: 120,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.primary.light,
  borderRadius: theme.spacing(2),
}));

const StyledIcon = styled(AddPhotoAlternate)(({ theme }) => ({
  fontSize: 60,
  color: theme.palette.primary.main,
}));

const PlusBadge = styled(Box)(({ theme }) => ({
  position: 'absolute',
  bottom: 8,
  right: 8,
  width: 32,
  height: 32,
  borderRadius: '50%',
  backgroundColor: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: `2px solid ${theme.palette.background.paper}`,
}));

const PlusText = styled(Text)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  fontSize: '20px',
  fontWeight: 'bold',
  lineHeight: 1,
}));

const TextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const TitleText = styled(Text)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
  textAlign: 'center',
  fontSize: '20px',
}));

const SubtitleText = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: 'center',
  fontSize: '16px',
  fontWeight: 400,
}));

export const DragDropOverlay = ({ isVisible }: DragDropOverlayProps) => {
  if (!isVisible) {
    return null;
  }

  return (
    <OverlayContainer>
      <ContentBox>
        <IconContainer>
          <StyledIcon />
          <PlusBadge>
            <PlusText>+</PlusText>
          </PlusBadge>
        </IconContainer>
        <TextContainer>
          <TitleText variant="h6">Add an image to chat about</TitleText>
          <SubtitleText variant="body2">jpeg, jpg, png, webp</SubtitleText>
        </TextContainer>
      </ContentBox>
    </OverlayContainer>
  );
};
